import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-line text-2xl text-primary-400"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-50">
                港片影志
              </span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              香港电影影史专业参考平台，系统梳理香港三级片的发展历程、经典作品与文化影响，为影迷提供权威的影史解读。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-200 mb-4">
              分类导航
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-200 mb-4">
              关于本站
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <span className="text-sm text-foreground-500">
                  联系邮箱：contact@pczqmcf.cn
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800">
          <p className="text-xs text-foreground-500 text-center">
            &copy; {new Date().getFullYear()} 港片影志。本站内容仅供影史研究与文化交流，不含任何不当内容。
          </p>
        </div>
      </div>
    </footer>
  );
}